export class PaymentSupport
{
    static getPaymentValue(liveValue)
    {
        return liveValue ?? "0.00";    
    }

    static PaymentAPIRequest(methodUrl, data)
    {
        return fetch(`${process.env.REACT_APP_PAYMENTS_API_PATH}/api/payments/${methodUrl}`, {
            method: "POST",
            body: JSON.stringify(data),
            headers: this.DefaultPostHeaders,
        }).then(result => {
            return result.json();
        });
    }

    static DefaultPostHeaders = 
    {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Access-Control-Allow-Origin':'*'
    }

    static AuthData = 
    {
        merchant: process.env.REACT_APP_PAYMENTS_MERCHANT,
        account: process.env.REACT_APP_PAYMENTS_ACCOUNT,
        key: process.env.REACT_APP_PAYMENTS_KEY,
        appId: process.env.REACT_APP_PAYMENTS_API_TOKEN,
        appKey: process.env.REACT_APP_PAYMENTS_API_KEY,
        apiPath: `${process.env.REACT_APP_PAYMENTS_API_PATH}/api/payments`,
        testMode: process.env.REACT_APP_PAYMENTS_TEST_MODE === "true" ? true : false
    }

}

export default PaymentSupport;